<header class="topbar px-3 py-2 surface-0" role="banner">
  <div *ngIf="loading" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="error" class="error-message p-2">
    <p-message severity="error" [text]="error"></p-message>
  </div>

  <div class="flex justify-between align-items-center w-full">
    <!-- Logo -->
    <div class="flex align-items-center">
      <a
        routerLink="/"
        class="no-underline text-white flex align-items-center"
        aria-label="Ir para página inicial"
      >
        <p-image
          src="../../../assets/imagem/Promptus_Logos-01.svg"
          alt="Logo CNJ"
          width="180"
          class="mr-2"
        ></p-image>
      </a>
    </div>

    <!-- Menu -->
    <div class="flex align-items-center gap-3 ml-auto">
      <p-megaMenu
        *ngIf="!isMobile"
        [model]="items"
        class="hidden md:block"
        role="navigation"
        aria-label="Menu principal"
      ></p-megaMenu>

      <!-- Botão para abrir o menu mobile -->
      <button
        *ngIf="isMobile"
        class="p-button p-button-text p-button-plain"
        (click)="toggleSidebar()"
        type="button"
        [attr.aria-expanded]="sidebarVisible"
        aria-label="Abrir menu"
        aria-controls="mobile-menu"
      >
        <i class="pi pi-bars text-2xl"></i>
      </button>
    </div>
  </div>
</header>

<!-- Sidebar -->
<p-sidebar
  [(visible)]="sidebarVisible"
  [baseZIndex]="10000"
  position="left"
  id="mobile-menu"
  role="navigation"
  aria-label="Menu mobile"
  [style]="{ width: '300px' }"
  [modal]="true"
  [dismissible]="true"
  [showCloseIcon]="true"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between p-2">
      <p-image
        src="../../../assets/imagem/Promptus_Logos-01.svg"
        alt="Logo CNJ"
        width="100"
        class="mr-2"
      ></p-image>
    </div>
  </ng-template>

  <div class="flex flex-column h-full">
    <div class="flex-grow-1">
      <p-panelMenu
        [model]="mobileMenuItems"
        styleClass="w-full"
        [multiple]="false"
      ></p-panelMenu>
    </div>

    <div class="p-3 border-top-1 surface-border">
      <button
      *ngIf="isUserLoggedIn"
      pButton
      icon="pi pi-user"
      styleClass="p-button-sm p-button-outlined w-full"
      class="bt-tema"
      (click)="logout()"
      aria-label="Sair da conta"
      >
      Sair
      </button>
    </div>
    </div>

</p-sidebar>
